<template>
   <by-days v-if="content.BookingActType === 'byDays'"
      :content="content"
      :config="config"
      :locale="locale"
      :isDesktop="isDesktop"
      :bookingWorkspaceID="bookingWorkspaceID"
   />
   <by-activities v-else-if="content.BookingActType === 'byActivities'"
      :content="content"
      :config="config"
      :locale="locale"
      :isDesktop="isDesktop"
      :bookingWorkspaceID="bookingWorkspaceID"
   />
   <by-events v-else-if="content.BookingActType === 'byEvents'"
      :content="content"
      :config="config"
      :locale="locale"
      :isDesktop="isDesktop"
      :bookingWorkspaceID="bookingWorkspaceID"
   />
   <by-hours v-else
      :content="content"
      :config="config"
      :locale="locale"
      :isDesktop="isDesktop"
      :bookingWorkspaceID="bookingWorkspaceID"
      :filterType="filterType"
   />
</template>

<script>
import ByHours from './byHours/Index'
import ByEvents from './byEvents/Index'
import ByDays from './byDays/Index'
import ByActivities from './byActivities/Index'
export default {
   name:'Item48BookActivities',
   components: {
      ByEvents,
      ByHours,
      ByDays,
      ByActivities,
   },
   props: {
      content: {
         type: Object,
         default: null,
      },
      config: {
         type: Object,
         default: null,
      },
      locale: {
         type: String,
         default: null,
      },
      isDesktop: {
         type: Boolean,
         default: false,
      },
      bookingWorkspaceID: {
         type: String,
         default: null,
      },
      filterType: {
         type: String,
         default: null,
      },
   },
   mounted () {
   },
}
</script>

